// 10-keypoint subset, sapiens2 indices, and skeleton edges.
// Spec reference: spec.md §5.2 (indices) and §6.3.3 (edges).
//
// Note: sapiens2's keypoints308 layout is non-standard — `right_wrist` (41)
// and `left_wrist` (62) are NOT adjacent to the elbows. An off-by-one here
// silently corrupts every annotation produced by the app.

import type { KeypointName } from '../types';

// Single source of truth for which joints we demonstrate. Both loaders
// (video, image) filter their inputs to this set. To re-enable a joint,
// un-comment the entry here AND the matching union member in
// `frontend/src/types/index.ts`.
export const KEYPOINTS = [
  // { name: 'left_shoulder', sapiensIndex: 5 },
  // { name: 'right_shoulder', sapiensIndex: 6 },
  // { name: 'left_elbow', sapiensIndex: 7 },
  // { name: 'right_elbow', sapiensIndex: 8 },
  // { name: 'left_hip', sapiensIndex: 9 },
  // { name: 'right_hip', sapiensIndex: 10 },
  // { name: 'left_knee', sapiensIndex: 11 },
  // { name: 'right_knee', sapiensIndex: 12 },
  // { name: 'right_wrist', sapiensIndex: 41 },
  // { name: 'left_wrist', sapiensIndex: 62 },
  { name: 'left_shoulder', sapiensIndex: 0 },
  { name: 'right_shoulder', sapiensIndex: 1 },
  { name: 'left_elbow', sapiensIndex: 2 },
  { name: 'right_elbow', sapiensIndex: 3 },
  { name: 'pelvis', sapiensIndex: 4 },
] as const satisfies ReadonlyArray<{ name: KeypointName; sapiensIndex: number }>;

export const KEYPOINT_NAMES: ReadonlySet<KeypointName> = new Set(KEYPOINTS.map((k) => k.name));

// export const SKELETON_EDGES = [
//   ['left_shoulder', 'left_elbow'],
//   ['left_elbow', 'left_wrist'],
//   ['right_shoulder', 'right_elbow'],
//   ['right_elbow', 'right_wrist'],
//   // ['left_hip', 'left_knee'],
//   // ['right_hip', 'right_knee'],
//   ['left_shoulder', 'right_shoulder'],
//   ['left_hip', 'right_hip'],
//   ['left_shoulder', 'left_hip'],
//   ['right_shoulder', 'right_hip'],
// ] as const satisfies ReadonlyArray<readonly [KeypointName, KeypointName]>;

export const SKELETON_EDGES = [
  ['left_shoulder', 'left_elbow'],
  ['right_shoulder', 'right_elbow'],
  ['left_shoulder', 'right_shoulder'],
  ['left_shoulder', 'pelvis'],
  ['right_shoulder', 'pelvis'],
] as const satisfies ReadonlyArray<readonly [KeypointName, KeypointName]>;

// Per-side visible keypoints.
// head_left: left arm only (left_shoulder, left_elbow, left_wrist)
// head_right: right arm only (right_shoulder, right_elbow, right_wrist)
// front views: all 10 keypoints
type SideId = 'front_left' | 'front_right' | 'left' | 'right';

const LEFT_CAMERA_KPS: ReadonlySet<KeypointName> = new Set<KeypointName>([
  'left_shoulder',
  'left_elbow',
  // 'left_wrist',
]);
const RIGHT_CAMERA_KPS: ReadonlySet<KeypointName> = new Set<KeypointName>([
  'right_shoulder',
  'right_elbow',
  // 'right_wrist',
]);

export function visibleKeypoints(side: SideId): ReadonlySet<KeypointName> {
  if (side === 'left') return LEFT_CAMERA_KPS;
  if (side === 'right') return RIGHT_CAMERA_KPS;
  return KEYPOINT_NAMES;
}
